import { Link } from "react-router-dom";
import { ImCart } from "react-icons/im";
import { MdOutlineInput } from "react-icons/md";

import { useProducts } from "../../providers/products";
import { useCart } from "../../providers/cart";
import Header from "../../components/Header";
import Button from "../../components/Button";

import { Container, Content } from "./styles";

const Home = () => {
  const { products } = useProducts();
  const { cart, addToCart } = useCart();

  return (
    <>
      <Header>
        <div>
          <h1>
            Kenzie Shop <br /> <span>Vintage</span>
          </h1>
        </div>
        <div className="icons">
          <Link to="/cart">
            <ImCart/>
            {cart.length > 0 && <span>{cart.length}</span>}
          </Link>
          <MdOutlineInput cursor="pointer" />
        </div>
      </Header>
      <Container>
        <Content>
          {products.map((product, index) => (
            <div key={index}>
              <p>
                <strong>{product.name}</strong>
              </p>
              <p>
                <span>R$ {product.price}</span>
              </p>
              <img src={product.image} alt={product.name} />
              <Button type="button" onClick={() => addToCart(product)}>
                Adicionar
              </Button>
            </div>
          ))}
        </Content>
      </Container>
    </>
  );
};

export default Home;
